import { enableMapSet, setAutoFreeze } from 'immer';
/**
 * Cases state stores `artifactSet` as a Set; RTK reducers use Immer. This must run on the same
 * immer module as @reduxjs/toolkit before any produce() runs.
 * Rspack `resolve.alias.immer` must point at `immer/dist/immer.mjs` (ESM), not the CJS entry
 * `require.resolve('immer')` would pick — otherwise enableMapSet patches a different instance.
 */ enableMapSet();
/**
 * TEMPORARY: RTK cutover safety net (CDMX-15555). Disables Immer's auto-freeze so legacy
 * in-place mutations on selector results (`.sort()`, `.splice()`, `.reverse()`) don't throw
 * `TypeError: Cannot assign to read only property...` post-cutover.
 *
 * Trade-off: mutation bugs become silent. Selector identity drift can cause stale renders.
 * Apollo Client's frozen `response.data.*` is NOT covered by this and must be fixed in CDMX-15556.
 *
 * Remove this call in CDMX-15557 once CDMX-15556 lands.
 */ setAutoFreeze(false);
